import { useSearchParams } from "react-router-dom";
function ImageHolder(props) {
    const [searchParams] = useSearchParams();
    const image = searchParams.get("image");
    return (
       <div className="image-holder-section">
         <img src={image} alt="mystar" />
       </div>
    )
}
export default ImageHolder;